import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationDailyCounters } from '@/api/bairun/financialCenter';
import NP from 'number-precision';
import moment from 'moment';
import dateUtils from '@/utils/dateUtil';
export default {
  name: 'SlotCounterFinancialDiff',
  props: {
    end: {
      type: Date,
      required: true
    },
    stationId: {
      type: Number,
      required: true
    },
    appId: {
      type: String,
      required: true
    },
    sellerName: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      data: {},
      sheetUnLoadCount: 1,
      stationDailyDiffData: []
    };
  },
  computed: {},
  watch: {
    end: function end() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['stationDailyDiffData' + _this.stationId].doLayout();
      });
      this.loadData();
    }
  },
  created: function created() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs['stationDailyDiffData' + _this2.stationId].doLayout(); // console.log('refsUpdate')

    });
    this.loadData();
  },
  updated: function updated() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.$refs['stationDailyDiffData' + _this3.stationId].doLayout(); // console.log('refsUpdate')

    });
  },
  methods: {
    numberFix: function numberFix(number, len) {
      return dateUtils.numberFix(number, len);
    },
    npPlus: function npPlus() {
      var res = 0;

      for (var i in arguments) {
        res = arguments[i] !== undefined ? NP.plus(res, arguments[i]) : res;
      }

      return res;
    },
    npMinus: function npMinus() {
      var res = arguments[0];

      for (var i in arguments) {
        res = arguments[i] !== undefined && i > 0 ? NP.minus(res, arguments[i]) : res;
      }

      return res;
    },
    amountFormat: function amountFormat(value) {
      return NP.round(value, 2);
    },
    npPlusArr: function npPlusArr(arr) {
      var res = 0;

      for (var i in arr) {
        // // console.log('arr', i, arr.length, arr[i], Number(arr[i]))
        res = NP.plus(res, Number(arr[i]));
      }

      return res;
    },
    getSummaries: function getSummaries(param) {
      var _this4 = this;

      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        var values;

        if (column.property === 'dailyCashDeposit.depositValue') {
          values = data.map(function (item) {
            return Number(item['dailyCashDeposit']['depositValue']);
          });
        } else if (column.property === 'dailyCashDeposit.depositLeftValue') {
          values = data.map(function (item) {
            return Number(item['dailyCashDeposit']['depositLeftValue']);
          });
        } else if (column.property === 'selfDiscount') {
          values = data.map(function (item) {
            return item['xwlCapitalDiscount'] ? NP.minus(Number(item['selfDiscount']), Number(item['xwlCapitalDiscount'])) : Number(item['selfDiscount']);
          });
        } else {
          values = data.map(function (item) {
            return Number(item[column.property]);
          });
        }

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = _this4.numberFix(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });
      return sums;
    },
    loadData: function loadData() {
      var _this5 = this;

      getStationDailyCounters({
        appId: this.appId,
        sellerId: this.stationId,
        startDate: moment(this.end).format('YYYYMM01'),
        endDate: moment(this.end).endOf('month').format('YYYYMMDD')
      }).then(function (response) {
        // // console.log('getStationDailyDiff', response)
        _this5.stationDailyDiffData = response.data;

        if (_this5.stationDailyDiffData.length > 0) {
          var _that = _this5;
          _this5.sheetUnLoadCount = 0;

          _this5.stationDailyDiffData.forEach(function (row) {
            var elRow = row;
            elRow.diesel0Nums = 0;
            elRow.diesel0Amount = 0;
            elRow.petrol92Nums = 0;
            elRow.petrol92Amount = 0;
            elRow.petrol95Nums = 0;
            elRow.petrol95Amount = 0;
            elRow.oilNums = 0;
            elRow.oilAmount = 0; // 油品回罐升数

            elRow.oilReturnNums = 0;
            elRow.oilReturnAmount = 0; // 油品自用升数

            elRow.oilWarnNums = 0;
            elRow.oilWarnAmount = 0; // 油品异常升数

            elRow.oilWarnNums = 0;
            elRow.oilWarnAmount = 0; // 油品销量升数

            elRow.oilSaleNums = 0;
            elRow.oilSaleAmount = 0; // 优惠

            elRow.selfDiscount = 0;
            elRow.tradeDiscount = 0;
            elRow.platDiscount = 0;
            elRow.cashAmount = 0; // 现金

            elRow.svcAmount = 0; // 卡消费

            elRow.walletAmount = 0; // 电子钱包

            elRow.creditAmount = 0; // 授权卡

            elRow.accountAmount = 0; // 记账卡

            elRow.onlineAmount = 0; // 通联在线支付

            elRow.onlineHuAmount = 0; // 通联在线支付（户）

            elRow.onlineGeAmount = 0; // 通联在线支付（个）

            elRow.posAmount = 0; // 通联POS机

            elRow.lklOnlineAmount = 0; // 拉卡拉在线支付

            elRow.lklOnlineHuAmount = 0; // 拉卡拉在线支付（户）

            elRow.lklOnlineGeAmount = 0; // 拉卡拉在线支付（个）

            elRow.lklPosAmount = 0; // 拉卡拉POS机

            elRow.fyOnlineAmount = 0; // 富友在线支付

            elRow.fyOnlineHuAmount = 0; // 富友在线支付（户）

            elRow.fyOnlineGeAmount = 0; // 富友在线支付（个）

            elRow.fyPosAmount = 0; // 富友POS机

            elRow.xyPosAmount = 0; // 星驿POS机

            elRow.transferAmount = 0; // 转账

            elRow.otherAmount = 0; // 其他 挂账等

            elRow.plat1008Amount = 0; // 刷脸付

            elRow.plat2001Amount = 0; // 滴滴

            elRow.plat2002Amount = 0; // 货车帮

            elRow.plat2003Amount = 0; // 易加油

            elRow.plat2004Amount = 0; // 团油

            elRow.plat2005Amount = 0; // 小象

            elRow.plat2007Amount = 0; // 嗨卡

            elRow.plat2008Amount = 0; // 喂车车

            elRow.plat2009Amount = 0; // 途虎

            elRow.plat2010Amount = 0; // 货拉拉

            elRow.plat2011Amount = 0; // 百思达

            elRow.plat2012Amount = 0; // 爱车平台

            elRow.plat2013Amount = 0; // 团油车队

            elRow.plat2014Amount = 0; // 鲸车惠

            elRow.lossCardAmount = 0; // 挂失补办

            elRow.shopAmount = 0; // 便利店

            elRow.loadometerAmount = 0; // 地磅计费

            elRow.walletChargeAmount = 0; // 钱包充值

            elRow.chargeAmount = 0; // 卡充值

            elRow.chargeBackAmount = 0; // 退卡/回款

            elRow.walletChargeAmount = 0; // 钱包充值

            elRow.xwlCapitalDiscount = 0; // 新文旅出资

            elRow.totalReceivableAmount = 0; // 合计

            elRow.totalDiff = 0; // 差异

            if (row.dailyPayWayData.length > 0) {
              row.dailyPayWayData.forEach(function (el, index) {
                if (el.payWay === 1001) {
                  // 现金
                  var tempDailyCheckPaymentsAmount = el.checkPaymentsAmount.split('|');
                  tempDailyCheckPaymentsAmount.push(0);
                  tempDailyCheckPaymentsAmount.push(0);
                  tempDailyCheckPaymentsAmount.push(0);
                  elRow.cashAmountArr = tempDailyCheckPaymentsAmount.slice(0, 3);
                  elRow.cashAmount = elRow.cashAmountArr && elRow.cashAmountArr.length > 0 ? _that.npPlusArr(elRow.cashAmountArr) : 0;
                } else if (el.payWay === 1002) {
                  // 卡消费
                  elRow.svcAmount = el.stationAmount;
                } else if (el.payWay === 1010) {
                  // 电子钱包
                  elRow.walletAmount = NP.minus(el.receivablesAmount, el.tradeDiscount);
                } else if (el.payWay === 7002) {
                  // 授权卡
                  elRow.creditAmount = el.stationAmount;
                } else if (el.payWay === 7005) {
                  // 记账卡
                  elRow.accountAmount = el.stationAmount;
                } else if (el.payWay === 1003 || el.payWay === 1004) {
                  // 通联在线支付
                  elRow.onlineAmount = elRow.onlineAmount !== undefined ? NP.plus(elRow.onlineAmount, el.receivablesAmount) : el.receivablesAmount;

                  if (el.receivablesRatio !== undefined) {
                    elRow.onlineHuAmount = NP.times(elRow.onlineAmount, el.receivablesRatio / 100);
                    elRow.onlineGeAmount = NP.minus(elRow.onlineAmount, elRow.onlineHuAmount);
                  }
                } else if (el.payWay === 1013 || el.payWay === 1014) {
                  // 拉卡拉在线支付
                  elRow.lklOnlineAmount = elRow.lklOnlineAmount !== undefined ? NP.plus(elRow.lklOnlineAmount, el.receivablesAmount) : el.receivablesAmount;

                  if (el.receivablesRatio !== undefined) {
                    elRow.lklOnlineHuAmount = NP.times(elRow.lklOnlineAmount, el.receivablesRatio / 100);
                    elRow.lklOnlineGeAmount = NP.minus(elRow.lklOnlineAmount, elRow.lklOnlineHuAmount);
                  }
                } else if (el.payWay === 1023 || el.payWay === 1024) {
                  // 富友在线支付
                  elRow.fyOnlineAmount = elRow.fyOnlineAmount !== undefined ? NP.plus(elRow.fyOnlineAmount, el.receivablesAmount) : el.receivablesAmount;

                  if (el.receivablesRatio !== undefined) {
                    elRow.fyOnlineHuAmount = NP.times(elRow.fyOnlineAmount, el.receivablesRatio / 100);
                    elRow.fyOnlineGeAmount = NP.minus(elRow.fyOnlineAmount, elRow.fyOnlineHuAmount);
                  }
                } else if (el.payWay === 1005) {
                  // 通联POS机
                  elRow.posAmount = el.checkPaymentsAmount;
                } else if (el.payWay === 1015) {
                  // 拉卡拉POS机
                  elRow.lklPosAmount = el.checkPaymentsAmount;
                } else if (el.payWay === 1025) {
                  // 富友POS机
                  elRow.fyPosAmount = el.checkPaymentsAmount;
                } else if (el.payWay === 1045) {
                  // 星驿POS机
                  elRow.xyPosAmount = el.checkPaymentsAmount;
                } else if (el.payWay === 1006) {
                  // 转账
                  elRow.transferAmount = el.checkPaymentsAmount;
                } else if (el.payWay === 1009) {
                  // 其他 挂账等
                  elRow.otherAmount = elRow.otherAmount !== undefined ? NP.plus(elRow.otherAmount, el.checkPaymentsAmount) : el.checkPaymentsAmount;
                } else if (el.payWay === 1008) {
                  // 刷脸付
                  elRow.plat1008Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2001) {
                  // 滴滴
                  elRow.plat2001Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2002) {
                  // 货车帮
                  elRow.plat2002Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2003) {
                  // 易加油
                  elRow.plat2003Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2004) {
                  // 团油
                  elRow.plat2004Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2005) {
                  // 小象
                  elRow.plat2005Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2007) {
                  // 嗨卡
                  elRow.plat2007Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2008) {
                  // 喂车车
                  elRow.plat2008Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2009) {
                  // 途虎
                  elRow.plat2009Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2010) {
                  // 货拉拉
                  elRow.plat2010Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2011) {
                  // 佰思达
                  elRow.plat2011Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2012) {
                  // 爱车平台
                  elRow.plat2012Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2013) {
                  // 团油车队
                  elRow.plat2013Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 2014) {
                  // 鲸车惠
                  elRow.plat2014Amount = el.checkPaymentsAmount;
                  elRow.platDiscount = elRow.platDiscount !== undefined ? NP.plus(elRow.platDiscount, NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount)) : NP.minus(el.checkPayablesAmount, el.checkPaymentsAmount);
                } else if (el.payWay === 7001) {
                  // 挂失补办
                  elRow.lossCardAmount = el.receivablesAmount;
                }

                elRow.shopAmount = elRow.shopAmount !== undefined ? NP.plus(elRow.shopAmount, el.shopAmount) : el.shopAmount;
                elRow.loadometerAmount = elRow.loadometerAmount !== undefined ? NP.plus(elRow.loadometerAmount, el.loadometerAmount) : el.loadometerAmount;
              });
              elRow.svcAmount = elRow.svcAmount !== undefined ? elRow.creditAmount !== undefined ? NP.minus(elRow.svcAmount, elRow.creditAmount) : elRow.svcAmount : 0;
              elRow.svcAmount = elRow.svcAmount !== undefined ? elRow.accountAmount !== undefined ? NP.minus(elRow.svcAmount, elRow.accountAmount) : elRow.svcAmount : 0;
            }

            if (row.dailyGoodsData.length > 0) {
              row.dailyGoodsData.forEach(function (el) {
                if (el.sellerOrderType === 4) {
                  // 充值数据
                  if (el.goodsSpu === 'spu1000000004') {
                    // 钱包充值
                    elRow.walletChargeAmount = elRow.walletChargeAmount !== undefined ? NP.plus(elRow.walletChargeAmount, el.receivablesAmount) : el.receivablesAmount;
                  } else if (el.goodsSpu === 'loss1000000001') {
                    return;
                  } else {
                    elRow.chargeAmount = elRow.chargeAmount !== undefined ? NP.plus(elRow.chargeAmount, el.receivablesAmount) : el.receivablesAmount;
                  }

                  if (el.receivablesAmount < 0) {
                    elRow.chargeBackAmount = elRow.chargeBackAmount !== undefined ? NP.plus(elRow.chargeBackAmount, el.receivablesAmount) : el.receivablesAmount;
                  }

                  return;
                }

                if (el.goodsSpu === '0') {
                  // 柴油
                  elRow.diesel0Nums = el.goodsNums;
                  elRow.diesel0Amount = el.payablesAmount;
                } else if (el.goodsSpu === '92') {
                  // 汽油 92
                  elRow.petrol92Nums = el.goodsNums;
                  elRow.petrol92Amount = el.payablesAmount;
                } else if (el.goodsSpu === '95') {
                  // 汽油 95
                  elRow.petrol95Nums = el.goodsNums;
                  elRow.petrol95Amount = el.payablesAmount;
                } // 油品油机升数


                elRow.oilNums = elRow.oilNums !== undefined ? NP.plus(elRow.oilNums, el.goodsNums) : el.goodsNums;
                elRow.oilAmount = elRow.oilAmount !== undefined ? NP.plus(elRow.oilAmount, el.payablesAmount) : el.payablesAmount; // 油品回罐升数

                elRow.oilReturnNums = elRow.oilReturnNums !== undefined ? NP.plus(elRow.oilReturnNums, el.returnGoodsNums) : el.returnGoodsNums;
                elRow.oilReturnAmount = elRow.oilReturnAmount !== undefined ? NP.plus(elRow.oilReturnAmount, el.returnPayablesAmount) : el.returnPayablesAmount; // 油品自用升数

                elRow.oilWarnNums = elRow.oilWarnNums !== undefined ? NP.plus(elRow.oilWarnNums, el.selfGoodsNums) : el.selfGoodsNums;
                elRow.oilWarnAmount = elRow.oilWarnAmount !== undefined ? NP.plus(elRow.oilWarnAmount, el.selfPayablesAmount) : el.selfPayablesAmount; // 油品异常升数

                elRow.oilWarnNums = elRow.oilWarnNums !== undefined ? NP.plus(elRow.oilWarnNums, el.warnGoodsNums) : el.warnGoodsNums;
                elRow.oilWarnAmount = elRow.oilWarnAmount !== undefined ? NP.plus(elRow.oilWarnAmount, el.warnPayablesAmount) : el.warnPayablesAmount; // 油品销量升数

                elRow.oilSaleNums = NP.minus(elRow.oilNums, elRow.oilReturnNums, elRow.oilWarnNums);
                elRow.oilSaleAmount = NP.minus(elRow.oilAmount, elRow.oilReturnAmount, elRow.oilWarnAmount); // 优惠

                elRow.selfDiscount = elRow.selfDiscount !== undefined ? NP.plus(elRow.selfDiscount, el.discountAmount) : el.discountAmount;
                elRow.tradeDiscount = elRow.tradeDiscount !== undefined ? NP.plus(elRow.tradeDiscount, el.tradeDiscount) : el.tradeDiscount;
              });
            }

            if (row.dailyDiscountCapital.length > 0) {
              row.dailyDiscountCapital.forEach(function (el2) {
                if (el2.capitalCategory === 2) {
                  elRow.xwlCapitalDiscount = elRow.xwlCapitalDiscount !== undefined ? NP.plus(elRow.xwlCapitalDiscount, el2.capitalAmount) : el2.capitalAmount;
                }
              });
            }

            elRow.totalReceivableAmount = _that.npPlus(elRow.cashAmount, elRow.transferAmount, elRow.svcAmount, elRow.walletAmount, elRow.creditAmount, elRow.accountAmount, elRow.posAmount, elRow.onlineAmount, elRow.lklPosAmount, elRow.lklOnlineAmount, elRow.fyPosAmount, elRow.xyPosAmount, elRow.fyOnlineAmount, elRow.plat1008Amount, elRow.plat2001Amount, elRow.plat2002Amount, elRow.plat2003Amount, elRow.plat2004Amount, elRow.plat2005Amount, elRow.plat2007Amount, elRow.plat2008Amount, elRow.plat2009Amount, elRow.plat2010Amount, elRow.plat2011Amount, elRow.plat2012Amount, elRow.plat2013Amount, elRow.plat2014Amount, elRow.otherAmount, elRow.oilReturnAmount, elRow.oilWarnAmount);
            elRow.totalDiff = _that.amountFormat(_that.npMinus(elRow.totalReceivableAmount, -elRow.selfDiscount, -elRow.platDiscount, -elRow.tradeDiscount, elRow.oilAmount, elRow.shopAmount, elRow.chargeAmount, elRow.walletChargeAmount, elRow.loadometerAmount, elRow.lossCardAmount), 2);
          });
        }
      });
    }
  }
};